import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22985140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning alert-sm",
  role: "alert"
}
const _hoisted_3 = { class: "plan" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Plan", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Price", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Billed", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "notes" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Billing changes", -1))
const _hoisted_11 = { class: "list-unstyled billing" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { class: "amount" }
const _hoisted_14 = { class: "unit" }

import { computed, ref } from 'vue'
import { useSubscriptionStore } from '@/gp/SubscriptionStore'
import { defaultPlanId, subscriptionPlans } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import Modal from '@/util/Modal.vue'

interface BillingItem {
  id: string
  item: string
  amount: number
  precision?: number
  unit?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionConfirmPlanModal',
  emits: ["add"],
  setup(__props, { expose: __expose, emit }) {

__expose({
  open,
  addFailed,
})



const newPlanIdRef = ref<string>()
const failedRef = ref(false)
const modalRef = ref<InstanceType<typeof Modal>>()

const subStore = useSubscriptionStore()

const subRef = computed(() => {
  const keyList = subStore.getAsyncKeyListForSelf(LoadMode.EnsureLoaded)?.data
  const subs = subStore.getLoadedSubscriptionList(keyList?.keys ?? [])
  return subs?.at(0) // HACK: assume max 1 subscription for now
})
const currentPlanIdRef = computed(() => subRef.value?.items.at(0)?.price?.productId ?? defaultPlanId)
const currentPlanRef = computed(() => subscriptionPlans.find(p => p.id == currentPlanIdRef.value)!)
const newPlanRef = computed(() => subscriptionPlans.find(p => p.id == newPlanIdRef.value))
const currentPriceRef = computed(() => currentPlanRef.value.price ?? 0)
const newPriceRef = computed(() => newPlanRef.value?.price ?? 0)
const isNewRef = computed(() => !subRef.value)
const isUpgradeRef = computed(() => newPriceRef.value > currentPriceRef.value)

const billingItemsRef = computed(() => {
  const currentTermDays = subRef.value?.currentPeriodEnd?.diff(subRef.value.currentPeriodStart!, 'days').days ?? 0
  const remainingDays = subRef.value?.currentPeriodEnd?.diffNow('days').days ?? 0
  const items: BillingItem[] = []

  let total = 0
  if (isUpgradeRef.value && currentPriceRef.value > 0) {
    const currentTermPrice = currentPriceRef.value * currentPlanRef.value.termMonths!
    const credit = Math.round(currentTermPrice * (remainingDays / currentTermDays))
    items.push({ 
      id: 'creditDays', 
      item: 'Remaining time on current plan', 
      amount: remainingDays, 
      precision: 0, 
      unit: "days"
    })
    items.push({ 
      id: 'credit', 
      item: `Credit for remaining term`, 
      amount: credit, 
      unit: 'USD' 
    })
    total -= credit;
  }
  if (newPlanRef.value && newPriceRef.value > 0) {
    const newTermPrice = newPriceRef.value * newPlanRef.value.termMonths!    
    items.push({ 
      id: 'planCharge', 
      item: `New plan (${newPriceRef.value.toFixed(2)} x ${newPlanRef.value.termMonths} months)`, 
      amount: newTermPrice, 
      unit: "USD" 
    })
    total += newTermPrice
  }
  items.push({ 
    id: 'total', 
    item: 'Total billed today', 
    amount: total, 
    unit: 'USD' 
  })
  return items;
})

function open(newPlanId: string) {
  newPlanIdRef.value = newPlanId
  failedRef.value = false
  modalRef.value!.open()
}

async function changePlan() {
  if (!newPlanRef.value)
    return

  if (subRef.value) {
    try {
      if (newPlanRef.value.id == defaultPlanId) {
        await subStore.cancelAsync(subRef.value.id!)
      }
      else {
        await subStore.changePlanAsync(subRef.value!.id!, newPlanRef.value.id!)
      }
      modalRef.value!.close()
    }
    catch (error) {
      failedRef.value = true
      modalRef.value!.reset()
    }
  }
  else {
    emit('add', newPlanIdRef.value!) // let caller close modal
  }
}

function addFailed() {
  failedRef.value = true
  modalRef.value?.reset()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    "ok-disabled": failedRef.value,
    onOk: changePlan
  }, {
    title: _withCtx(() => [
      _createTextVNode("Change my plan")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Change plan")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (failedRef.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Sorry, something went wrong. Please try again later. "))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (isNewRef.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Are you sure you want to sign up for this plan?")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Are you sure you want to switch to this plan?")
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, _toDisplayString(newPlanRef.value?.displayName), 1),
          _hoisted_5,
          _createElementVNode("div", null, " $" + _toDisplayString((newPlanRef.value?.price ?? 0).toFixed(2)) + "/month ", 1),
          _hoisted_6,
          (newPlanRef.value?.price && newPlanRef.value.termMonths)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " $" + _toDisplayString((newPlanRef.value.price * newPlanRef.value.termMonths).toFixed(2)) + " for " + _toDisplayString(newPlanRef.value.termMonths) + " months ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (!isUpgradeRef.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Your subscription will continue on the current plan until your next billing cycle (" + _toDisplayString(subRef.value?.currentPeriodEnd?.toLocaleString()) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_10,
        _createElementVNode("ul", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingItemsRef.value, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.item,
              class: _normalizeClass(["billing-item", item.id])
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.item), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.amount.toFixed(item.precision ?? 2)), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(item.unit), 1)
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["ok-disabled"]))
}
}

})